export default "__VITE_ASSET__QCjWqp1V__"